import { categories } from "@/mocks/comicData";

const colorMap: Record<string, string> = {
  daily: "bg-primary-100 text-primary-700",
  office: "bg-accent-100 text-accent-700",
  food: "bg-secondary-200 text-secondary-800",
  pets: "bg-accent-100 text-accent-700",
  school: "bg-secondary-200 text-secondary-800",
  travel: "bg-primary-100 text-primary-700",
};

function Categories() {
  return (
    <section id="categories" className="container-page py-16 md:py-20">
      <div className="mb-10 flex flex-col items-start justify-between gap-4 md:flex-row md:items-end">
        <div>
          <span className="eyebrow">
            <i className="ri-price-tag-3-line"></i>
            主题分类
          </span>
          <h2 className="section-title mt-3">丫头的欢乐世界里都有啥</h2>
        </div>
        <p className="max-w-md text-sm leading-relaxed text-foreground-600">
          从柴米油盐到星辰大海，六大分类把大黄丫头漫画的搞笑日常整理得明明白白，轻松找你想看的那一抹笑点。
        </p>
      </div>

      <div className="grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
        {categories.map((cat) => (
          <article
            key={cat.id}
            className="group flex items-center gap-4 rounded-2xl bg-background-100 p-5 transition-transform duration-300 hover:-translate-y-1 hover:bg-background-200/60"
          >
            <span
              className={`flex h-14 w-14 shrink-0 items-center justify-center rounded-2xl text-2xl ${colorMap[cat.id]}`}
            >
              <i className={cat.icon}></i>
            </span>
            <div className="min-w-0 flex-1">
              <div className="flex items-center justify-between">
                <h3 className="font-heading text-lg text-foreground-950">{cat.title}</h3>
                <span className="rounded-full bg-background-50 px-2.5 py-0.5 text-xs font-bold text-foreground-500">
                  {cat.count}话
                </span>
              </div>
              <p className="mt-1 text-sm text-foreground-600">{cat.desc}</p>
            </div>
            <span className="text-foreground-300 transition-transform duration-300 group-hover:translate-x-1 group-hover:text-primary-500">
              <i className="ri-arrow-right-s-line text-xl"></i>
            </span>
          </article>
        ))}
      </div>
    </section>
  );
}

export default Categories;